(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hexo-cart-terms"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hexo-cart-terms')) {
    customElements.define('hexo-cart-terms', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.box = this.querySelector('input');
        const area = this.closest('.cart__ctas');
        this.button = area?.querySelector('[name="checkout"]');
        if (!this.box || !this.button) return;
        this.box.checked = false;
        const sync = () => { this.button.disabled = !this.box.checked || this.button.dataset.cartEmpty === 'true'; };
        this.box.addEventListener('change', sync, {signal});
        area.addEventListener('click', event => {
          if (event.target.closest('[name="checkout"]') && !this.box.checked) {
            event.preventDefault(); event.stopImmediatePropagation(); this.box.focus();
          }
        }, {capture:true, signal});
        document.addEventListener('submit', event => {
          if (event.submitter === this.button && !this.box.checked) {
            event.preventDefault(); event.stopImmediatePropagation(); this.box.focus();
          }
        }, {capture:true, signal});
        window.addEventListener('pageshow', () => { this.box.checked = false; sync(); }, {signal});
        sync();
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hexo-document-foundation"] && !Shopify.designMode) return;
  try {
    (() => {
  const enhanced = new Map();
  const initialize = () => {
    document.querySelectorAll('.hx-document-shell').forEach((shell) => {
      const help = shell.querySelector('[data-hx-document-help]');
      const destination = shell.querySelector('.cta-block');
      if (help && destination && help.parentElement !== destination) destination.append(help);
      shell.querySelectorAll('.pain-dots:not([data-hx-rating])').forEach((rating) => {
        const dots = rating.querySelectorAll('.pain-dot');
        if (!dots.length) return;
        const value = `${rating.querySelectorAll('.pain-dot.filled').length} / ${dots.length}`;
        rating.dataset.hxRating = value;
        rating.setAttribute('role', 'img');
        rating.setAttribute('aria-label', value);
        dots.forEach(dot => dot.setAttribute('aria-hidden', 'true'));
        const label = document.createElement('span');
        label.className = 'hx-pain-value';
        label.setAttribute('aria-hidden', 'true');
        label.textContent = value;
        rating.append(label);
      });
    });
    for (const [table, observer] of enhanced) {
      if (!table.isConnected) { observer.disconnect(); enhanced.delete(table); }
    }
    const label = document.querySelector('[data-hx-document-labels]')?.dataset.scrollHint;
    if (!label) return;
    document.querySelectorAll('.hexo-source-page table').forEach((table) => {
      if (enhanced.has(table) || table.closest('.hx-document-table')) return;
      const region = document.createElement('div');
      const hint = document.createElement('p');
      region.className = 'hx-document-table';
      region.setAttribute('role', 'region');
      const title = table.closest('.hexo-source-page').querySelector('h1')?.textContent.trim();
      region.setAttribute('aria-label', title ? `${title} — ${label}` : label);
      hint.className = 'hx-table-hint';
      hint.textContent = label;
      hint.hidden = true;
      table.before(hint, region);
      region.append(table);
      table.querySelectorAll('thead th:not([scope])').forEach(th => th.scope = 'col');
      const update = () => {
        const overflow = region.scrollWidth > region.clientWidth + 1;
        region.dataset.overflow = String(overflow);
        if (overflow) region.tabIndex = 0;
        else region.removeAttribute('tabindex');
        hint.hidden = !overflow;
      };
      const observer = new ResizeObserver(update);
      observer.observe(region);
      observer.observe(table);
      enhanced.set(table, observer);
      update();
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', () => queueMicrotask(initialize));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hexo-faq-document"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const prefix = root.closest('[id^="shopify-section-"]')?.id || 'hexo-faq';
    const buttons = root.querySelectorAll('.cat-btn');
    const sections = root.querySelectorAll('.cat-section');
    buttons.forEach((button) => {
      button.setAttribute('aria-pressed',String(button.classList.contains('active')));
      button.addEventListener('click', () => {
        buttons.forEach((item) => {item.classList.remove('active');item.setAttribute('aria-pressed','false');});
        sections.forEach((section) => section.classList.remove('active'));
        button.classList.add('active');
        button.setAttribute('aria-pressed','true');
        root.querySelector(`#cat-${button.dataset.cat}`)?.classList.add('active');
      });
    });
    const setOpen = (item, open) => {
      item.classList.toggle('open', open);
      item.querySelector('.faq-q')?.setAttribute('aria-expanded', String(open));
      const answer = item.querySelector('.faq-a');
      if (answer) answer.hidden = !open;
    };
    root.querySelectorAll('.faq-q').forEach((original, index) => {
      const question = document.createElement('button');
      question.type = 'button';
      question.className = original.className;
      question.append(...original.childNodes);
      const originalIcon = question.querySelector('.faq-icon');
      if (originalIcon) {
        const icon = document.createElement('span');
        icon.className = originalIcon.className;
        icon.setAttribute('aria-hidden', 'true');
        originalIcon.replaceWith(icon);
      }
      const heading = document.createElement('h3');
      heading.className = 'faq-question-heading';
      heading.append(question);
      original.replaceWith(heading);
      const answer = question.closest('.faq-item').querySelector('.faq-a');
      if (!answer) return;
      answer.id = `${prefix}-answer-${index}`;
      question.setAttribute('aria-controls', answer.id);
      question.setAttribute('aria-expanded', 'false');
      answer.hidden = true;
      const toggle = () => {
        const item = question.closest('.faq-item');
        const wasOpen = item.classList.contains('open');
        item.closest('.faq-list').querySelectorAll('.faq-item').forEach((faqItem) => {
          setOpen(faqItem, false);
        });
        if (!wasOpen) {
          setOpen(item, true);
        }
      };
      question.addEventListener('click', toggle);
    });
  };
  document.querySelectorAll('.hexo-source-page--hexo-faq').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target.querySelector('.hexo-source-page--hexo-faq'));
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hexo-floating-actions"] && !Shopify.designMode) return;
  try {
    (() => {
    let previewFrame;
    const updatePreviewInset = () => {
      const stack = document.querySelector('.hx-floating-actions');
      if (!stack) return;
      const box = previewFrame?.getBoundingClientRect();
      const visible = box && box.height > 0 && box.bottom >= innerHeight - 1
        && getComputedStyle(previewFrame).visibility !== 'hidden';
      const inset = visible ? (box.height > 160 ? 64 : Math.max(0, innerHeight - box.top)) : 0;
      stack.style.setProperty('--hx-floating-preview-inset', `${inset}px`);
    };
    const sizeObserver = new ResizeObserver(updatePreviewInset);
    const attributeObserver = new MutationObserver(updatePreviewInset);
    const bindPreviewFrame = () => {
      const next = document.getElementById('PBarNextFrame');
      if (next === previewFrame) return;
      sizeObserver.disconnect();
      attributeObserver.disconnect();
      previewFrame = next;
      if (previewFrame) {
        sizeObserver.observe(previewFrame);
        attributeObserver.observe(previewFrame, { attributes:true, attributeFilter:['style','class','hidden'] });
      }
      updatePreviewInset();
    };
    const start = () => {
      bindPreviewFrame();
      new MutationObserver(bindPreviewFrame).observe(document.body, { childList:true });
      window.addEventListener('resize', updatePreviewInset, { passive:true });
      document.addEventListener('shopify:section:load', updatePreviewInset);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hexo-jewelry-guide-document"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    root.querySelectorAll('.nav-item').forEach((item, index) => {
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      const navigate = () => root.querySelector(`#s${index + 1}`)?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      item.addEventListener('click', navigate);
      item.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          navigate();
        }
      });
    });
  };
  document.querySelectorAll('.hexo-source-page--hexo-jewelry-guide').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target.querySelector('.hexo-source-page--hexo-jewelry-guide'));
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hexo-shop-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hexo-shop-menu')) {
    customElements.define('hexo-shop-menu', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.tabs = [...this.querySelectorAll('[data-shop-tab]')];
        this.panels = [...this.querySelectorAll('[data-shop-panel]')];
        this.select(this.dataset.initialPanel);
        this.dataset.enhanced = '';
        this.addEventListener('click', event => {
          const tab = event.target.closest('[data-shop-tab]');
          if (tab) this.select(tab.dataset.shopTab);
        }, { signal });
        this.tabs.forEach(tab => tab.addEventListener('pointerenter', () => {
          if (matchMedia('(hover:hover) and (pointer:fine)').matches && !this.panels.some(panel => panel.contains(document.activeElement))) this.select(tab.dataset.shopTab);
        }, { signal }));
        this.addEventListener('keydown', event => {
          const tab = event.target.closest('[data-shop-tab]');
          const horizontal = this.classList.contains('hx-mobile-shop');
          const rtl = getComputedStyle(this).direction === 'rtl';
          const previous = horizontal ? (rtl ? 'ArrowRight' : 'ArrowLeft') : 'ArrowUp';
          const following = horizontal ? (rtl ? 'ArrowLeft' : 'ArrowRight') : 'ArrowDown';
          if (!tab || ![previous,following,'Home','End'].includes(event.key)) return;
          event.preventDefault();
          const i = this.tabs.indexOf(tab);
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (i + (event.key === following ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.select(this.tabs[next].dataset.shopTab);
          this.tabs[next].focus();
        }, { signal });
        this.closest('details').addEventListener('toggle', event => {
          if (event.currentTarget.open && !this.contains(document.activeElement)) this.select(this.dataset.initialPanel);
        }, { signal });
      }
      select(key) {
        this.tabs.forEach(tab => {
          const selected = tab.dataset.shopTab === key;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach(panel => { panel.hidden = panel.dataset.shopPanel !== key; });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
